import { gql } from "@apollo/client";

export const QUERY_PROJECT_CONFIG = gql`
  query projects($version: String, $tenantID: ID!) {
    alerts(tenantID: $tenantID) {
      id
      title
      message
      color
    }
    projects(tenantID: $tenantID) {
      id
      slug
      title
      logo
      namedQueries {
        id
        query
        name
        private
      }
      position
      insightsConfig {
        widgets {
          url
        }
        feed {
          url
        }
        queryBuilder {
          url
        }
      }
      nav {
        name
        props {
          insights_url
          queryBuilder
          mix
        }
      }
      boards(version: $version) {
        id
        title
        notes {
          body
          createdAt
          id
          title
          updatedAt
        }
        slug
        maintenance
        showGroups
        showFilters
        filterDimensions
        defaultFilter
        position
        isLive
        defaultGroup {
          name
          slug
        }
        defaultRegion {
          slug
          name
        }
        regions {
          id
          name
          slug
        }
        configs(version: $version) {
          id
          version
          contents {
            options
            widget
            props {
              title
              description
              url
              size
              insights
              csv_export
              tooltip
              goal
              cells
              chart
              table_filter
              columns
              funnels
              first_tick
              pagination
              footer
              maintenance
              metrics {
                name
                label
                format
                type
              }
            }
          }
        }
        regions {
          id
          name
          slug
        }
        archived
      }
    }
  }
`;

export const QUERY_LIST_TENANTS = gql`
  query {
    tenants {
      id
      name
      slug
    }
  }
`;

export const QUERY_LIST_GROUPS = gql`
  query Board($id: ID!, $tenantID: ID!) {
    board(id: $id, tenantID: $tenantID) {
      id
      groups {
        name
        slug
        id
      }
    }
  }
`;
